/* lua.js generated code 0.3.0 */

require("clover/data/ItemType")
require("clover/gamePlay/CreateGameSceneLogic")

var [StartPanel, StartPanelEvent] = unpack(require("clover/panel/StartPanel"))
var StartMainLevelLogic = xClass("StartMainLevelLogic")
StartMainLevelLogic.prototype.checkCanStart = function (levelId, extraData, notVague) {
    var self = this
    // 挑战模式下 都能进入游戏，无限制
    if (extraData && extraData.contestUid) {
        return [true, undefined]
    }
    var [success, errCode] = UserLevel.getInstance().canStartLevel(levelId, table(), null, notVague)
    if (success || errCode === ZooErrorCode.ENERGY_NOT_ENOUGH) {
        return [true, undefined]
    } else {
        return [false, errCode]
    }
}
StartMainLevelLogic.create = function (levelId, extraData) {
    var self = this
    var [success, errCode] = self.prototype.checkCanStart(levelId, extraData, true)
    if (!success) {
        return [null, errCode]
    }
    return [StartMainLevelLogic.new(levelId, extraData), undefined]
}
StartMainLevelLogic.prototype.ctor = function (levelId, extraData = {}) {
    var self = this
    self.levelId = levelId
    self.initProps = table()
    self.isBusy = false
    self.waitingPanelAnim = false
    self.successCallback = null
    self.failCallback = null
    self.lockedCoin = 0
    self.lockedCash = 0
    self.extraData = extraData
}
StartMainLevelLogic.prototype.start = function (successCallback, failCallback, needPanel = true, isReplay) {
    var self = this
    var context = self
    if (context.isBusy) {
        return
    }
    context.successCallback = function () {
        context.cleareInitPropCharge()
        if (successCallback) {
            successCallback()
        }
        PurpleAmyMagicManager.getInstance().cleanReplayBefor()
        // GoldElysiumManager.getInstance().getData().cleanReplayBefor()
        if (isReplay) {
            //重置活动连胜次数
            UserManager.getInstance().resetActivityStreakBuff(self.levelId);
            GoldElysiumManager.getInstance().getData().cleanWinningStreak()
            GoldElysiumManager.getInstance().dcGoldElysiumChangeResult(false, "replay", self.levelId)
        }
    }
    context.failCallback = function () {
        context.cleareInitPropCharge()
        if (failCallback) {
            failCallback()
        }
        // GoldElysiumManager.getInstance().getData().resumeReplayBefor()
        PurpleAmyMagicManager.getInstance().resumeReplayBefor()
    }

    if (window.mini && mini.getPlatform() == MiniPlatform.baidu) {
        // 百度防沉迷
        var sns = SnsProxy.getInstance();
        var lastState = sns.getAnitiAddictionState();
        var hasEnterGame = sns.getAntiAddictionHasEnterGame();
        if (lastState && hasEnterGame) {
            return;
        }
    }

    // 记录打关次数
    // let goldTurnLogic = require("activity/GoldTurn/GoldTurnLogic");
    GoldTurnLogic.getInstance().addLevelTimes();

    var HomeScene = require("clover/scene/HomeScene")
    if (HomeScene.created) {
        var scoreUpdate = UserScore.getInstance().checkLevelScoreUpdate(self.levelId)
        if (scoreUpdate) {
            HomeScene.getInstance().updateNode(self.levelId)
        }
    }
    // var panel = StartPanel.create(context.levelId, context.initPropConfig(), context.scoreConfig(), context.levelInfo())
    function onSuccess(panel) {
        self.panel = panel;
        panel.on(StartPanelEvent.StartClick, function (event) {
            if (context.waitingPanelAnim || context.isBusy) {
                return 
            }
            context.isBusy = true
            var checkEnergyStratLevel = function(){
                if (self.useComplementStar){
                    context.startLevel(event.target, param)
                    return
                }
                // checkEnergy会关闭StartPanel，导致获取不到关前广告组件，需要这里记录一下
                let adPropIds = event.target && event.target.adPrepropCmpt && event.target.adPrepropCmpt.getSelectedPropIds();
                let param = {adPropIds: adPropIds};
                if (context.checkEnergy(event.target, param)) {
                    context.startLevel(event.target, param)
                    VerifiedManager.getInstance().removeConsumeTip()
                }
            }
            // 使用补星道具不耗费精力

            // 是否是要用精力瓶的
            if (self.useEnergyPropId){
                let propData = {
                    propId: self.useEnergyPropId,
                    num: self.useEnergyPropNum
                }
                self.usePropAndStart(propData);
                panel.on(StartPanelEvent.UsePropAnimFinish, checkEnergyStratLevel);
            }else if (self.useComplementStar && self.useComplementStarPropId){
                let propData = {
                    propId: self.useEnergyPropId,
                    num: self.useEnergyPropNum
                }
                // self.usePropAndStart(propData);
                self.playUseEnergyPropAnim(self.useComplementStarPropId)
                panel.on(StartPanelEvent.UsePropAnimFinish, checkEnergyStratLevel);
            }else{
                checkEnergyStratLevel();
            }
        })
        panel.on(StartPanelEvent.PrePropSelect, function (event) {
            if (context.waitingPanelAnim || context.isBusy) {
                return
            }
            context.isBusy = true
            var [success, errCode] = [false , null];
            if(event.litmitedProp) {
                //限时限次道具在关卡打开后倒计时结束，也可以使用
                success = true;
                table.insert(context.initProps, event.litmitedProp);
                if(!self.litmitedProps) {
                    self.litmitedProps = {};
                } 
                if(!self.litmitedProps[event.litmitedProp]) {
                    self.litmitedProps[event.litmitedProp] = UserManager.getInstance().getUserTimePropNumber(event.litmitedProp);
                }
            }else {
                table.insert(context.initProps, event.propId);              
                let [success1, errCode1] = UserLevel.getInstance().canStartLevel(context.levelId, context.initProps);
                success = success1;
                errCode = errCode1;
            }

            if (success || errCode === ZooErrorCode.ENERGY_NOT_ENOUGH) {
                event.success = true
                if (UserProp.getInstance().getPropNumber(event.propId)[0] <= 0) {
                    context.refreshInitPropCharge()
                }
                context.isBusy = false
            } else if (errCode === ZooErrorCode.CASH_NOT_ENOUGH) {
                table.removebyvalue(context.initProps, event.propId)
                event.success = false
                if (!__ANDROID) {
                    // var CashNotEnoughPanel = require("clover/panel/CashNotEnoughPanel")
                    // var confirm = CashNotEnoughPanel.create(function () {
                    //     require("clover/panel/MarketPanel")
                    //     MarketPanel.show(MarketPanelTabId.kCashTab ,function (market) {
                    //         market.setCloseCallback(function () {
                    //             context.isBusy = false
                    //             market.clearCloseCallback()
                    //             panel.updateInitPropAfford()
                    //         })
                    //     })
                    // }, function () {
                    //     context.isBusy = false
                    //     panel.updateInitPropAfford()
                    // })
                    // confirm.popup(true)
                    require("clover/panel/CashNotEnoughPanel").show(function (showpanel) {
                        showpanel.on(BasePanelEvent.Close, ()=> {
                            context.isBusy = false
                            market.clearCloseCallback()
                            panel.updateInitPropAfford()
                        })

                        // require("clover/panel/MarketPanel")
                        // MarketPanel.show(MarketPanelTabId.kCashTab ,function (market) {
                        //     market.setCloseCallback(function () {
                        //         context.isBusy = false
                        //         market.clearCloseCallback()
                        //         panel.updateInitPropAfford()
                        //     })
                        // },function () {
                        //     context.isBusy = false
                        // })
                    }, function () {
                        context.isBusy = false
                        panel.updateInitPropAfford()
                    }, true)
                } else {
                    // require("clover/buyLogic/BuyLogic")
                    var goodsId = UserDealData.getGoodsIdForProp(event.propId)
                    var [logic, errCode] = BuyLogic.buySpecificGoods(goodsId, 1, true)
                    if (logic) {
                        logic.start(function () {
                            context.isBusy = false
                            panel.updatePrePropNum()
                            panel.selectPreProp(event.propId)
                        }, function () {
                            context.isBusy = false
                        }, function () {
                            context.isBusy = false
                        })
                    } else {
                        context.isBusy = false
                    }
                }
            } else if (errCode === ZooErrorCode.PROP_NOT_ENOUGH) {
                table.removebyvalue(context.initProps, event.propId)
                //  道具不足，弹出道具购买面板，传入的是Item表编号
                let buyPropPanel = event.customBuyPropPanel || require("clover/panel/StartBuyPropPanel");
                buyPropPanel.show(event.itemId, true, (buySuccess = false) => {
                    //  关闭回调
                    context.isBusy = false
                    //  刷新道具数量
                    panel.updatePrePropNum()
                    //  如果购买成功则自动选中该道具
                    if (buySuccess) {
                        table.insert(context.initProps, event.propId)
                        if (UserProp.getInstance().getPropNumber(event.propId)[0] <= 0) {
                            context.refreshInitPropCharge()
                        }
                        event.targetNode.select(true)
                    }
                },()=>{
                    //  关闭回调
                    if (context)context.isBusy = false
                })
            } else {
                context.isBusy = false
                table.removebyvalue(context.initProps, event.propId)
                event.success = false
                event.errCode = errCode
            }
        })
        panel.on(StartPanelEvent.PrePropCancel, function (event) {
            if (context.waitingPanelAnim) {
                return
            }
            if(event.litmitedProp) {
                table.removebyvalue(context.initProps, event.litmitedProp);
            }else {
                table.removebyvalue(context.initProps, event.propId);
            }
            context.refreshInitPropCharge()
        })
        panel.on(StartPanelEvent.Close, function (event) {
            if (context.waitingPanelAnim || context.isBusy) {
                return
            }
            context.isBusy = true
            event.target.onClose()
            VerifiedManager.getInstance().removeConsumeTip()
            if (type(context.failCallback) === "function") {
                context.failCallback()
            }
            ChampionLogic.getInstance().setAssignBtnClicked(false)
            BattlePassLogic.getInstance().setAssignBtnClicked(false)
            LightningRushManager.getInstance().setAssignBtnClicked(false)
        })
        panel.on(StartPanelEvent.StartAnim, function (event) {
            context.waitingPanelAnim = true
        })
        panel.on(StartPanelEvent.FinishAnim, function (event) {
            context.waitingPanelAnim = false
        })
        panel.on(StartPanelEvent.PropTouchHijack, function(event) {
            let busyRsp = event.busyRsp;
            let isBusy = context.waitingPanelAnim || context.isBusy;
            if (!isBusy) {
                context.isBusy = true;
                setTimeout(function(){context.isBusy = false}, 301)
            }
            busyRsp && busyRsp(isBusy)
        })
        panel.on(StartPanelEvent.AdStartClick, function(event){
            // console.log("adstart startevent click", event, self.panel)
            if (context.waitingPanelAnim || context.isBusy) {
                return 
            }
            context.isBusy = true

            var startgame = function(adStartItmesDc){
                cc.log("adStartItmesDc ",adStartItmesDc)
                //获取关前广告道具
                let adPropIds = event.target && event.target.adPrepropCmpt && event.target.adPrepropCmpt.getSelectedPropIds();
                let param = {adPropIds: adPropIds};

                if (event.target && event.target.adStartReward){
                    param = {adPropIds: adPropIds, adStartPropIds: event.target.adStartReward}
                }
                if (adStartItmesDc){
                    param.adStartItmesDc = adStartItmesDc
                }
                // if (context.checkEnergy(event.target, param)) {
                context.startLevel(event.target, param)
                VerifiedManager.getInstance().removeConsumeTip()
            }


            if (event.target && event.target.ttUseDiamond){
                context.ttUseDiamond = event.target.ttUseDiamond
            }
            //检查网络
            AdStartPropManager.getInstance().checkNetwork(()=> self.onClickAdShow(
                //看广告后，播动画后成功回调
                (adStartItmesDc)=>startgame(adStartItmesDc)
            ),function(){
                context.isBusy = false
                Toast.make(getText("clover.text.385"))
            })

            DCAssist.dc4User101("bef_stage_ad","ad_button_click",{session: AdStartPropManager.getInstance().createDCSession()})


            

        })
        panel.on(StartPanelEvent.BubbleClick, function(event){
            // console.log("adstart startevent click", event, self.panel)
            if (context.waitingPanelAnim || context.isBusy) {
                return 
            }
            context.isBusy = true

            let click_type = event.click_type;
            let propId = event.propId;
            if (propId){
                table.removebyvalue(context.initProps, self.useComplementStarPropId)
                self.useComplementStarPropId = propId
            }

            if (click_type == "select"){
                self.useComplementStar = self.useComplementStarPropId
                if(!table.indexOf(context.initProps || table(), self.useComplementStarPropId)) table.insert(context.initProps, self.useComplementStarPropId)
            }else{
                self.useComplementStar = null
                if(table.indexOf(context.initProps || table(), self.useComplementStarPropId)) table.removebyvalue(context.initProps, self.useComplementStarPropId)
            }
            context.isBusy = false
            cc.log("[AddStar] StartPanelEvent.BubbleClick ",context.initProps)
            // table.removebyvalue(context.initProps, event.propId)


        })
        panel.on(StartPanelEvent.PlayStrategy, function (event) {
            if (context.waitingPanelAnim || context.isBusy) {
                return
            }
            self.strategyId = event.strategyId;
            self.strategyContent = event.strategyContent;
            const isNewStrategy = event.isNewStrategy;
            context.isBusy = true;
            DCAssist.dc4ClickIcon("levelTip", "click_tip");
            let cb = ()=>{
                context.isBusy = false;
            }
            if (isNewStrategy){
                var snsProxy = require("clover/sns/SnsProxy").getInstance();
                if(snsProxy.allowAd() && snsProxy.isAdReady("Startegy")) {
                    self.showAdPrompt(true,cb);
                }else{
                    self.showAdPrompt(false,cb);
                }
            }else{
                self.gotoStrategy();
                cb();
            }
        })
        panel.popup(true)
    }
    // 判断是否使用补星道具
    self.useComplementStarPropId = null
    self.useComplementStar = null
    // 判断是要用精力瓶的按钮
    self.useEnergyPropId = null;
    self.useEnergyPropNum = 0;
    //  先检查当前玩家是否为无限精力状态，再决定是否要用精力瓶
    var userExtend = UserManager.getInstance().getUserExtendRef()
    var now = Localhost.time()
    var lastBuffTime = parseInt(userExtend.getNotConsumeEnergyBuff());
    if (lastBuffTime > now) {
        //  当前处于无限精力状态，不使用精力瓶
        // 判断当前关卡补星状态（是否有历史分数）是否有补星道具
        if (UserScore.getInstance().isNeedComplementStar(self.levelId) && ComplementStarManager.getInstance().getItemNum()){
            self.useComplementStarPropId = ComplementStarManager.getInstance().getItemUseId()
            self.useComplementStar = self.useComplementStarPropId
            if(!table.indexOf(context.initProps || table(), self.useComplementStarPropId)) table.insert(context.initProps, self.useComplementStarPropId)
        }
    } else {
        // 判断当前关卡补星状态（是否有历史分数）是否有补星道具
        if (UserScore.getInstance().isNeedComplementStar(self.levelId) && ComplementStarManager.getInstance().getItemNum()){
            self.useComplementStarPropId = ComplementStarManager.getInstance().getItemUseId()
            self.useComplementStar = self.useComplementStarPropId
            if(!table.indexOf(context.initProps || table(), self.useComplementStarPropId)) table.insert(context.initProps, self.useComplementStarPropId)
        }else{
            //  不处于无限精力状态，需要自动消耗精力瓶
            var user = UserManager.getInstance().getUserRef();
            var userEnergy = user.energy;
            var energy1PropNum = UserProp.getInstance().getPropNumber(GamePropsType.kEnergy1);
            var energy2PropNum = UserProp.getInstance().getPropNumber(GamePropsType.kEnergy2);
            var consume = MetaManager.getInstance().global.user_energy_level_consume || 5;
            var hasEquityMonthTicket = false
            //console.log("[monthticket] startmainlevellogic")
            if (hasEquityMonthTicket){
                consume = 4
            }
            cc.log("userEnergy", userEnergy, "consume", consume);
    
            if (userEnergy < consume){
                if (energy1PropNum >= consume){
                    // 足够数量的初级精力瓶
                    self.useEnergyPropId = GamePropsType.kEnergy1;
                    self.useEnergyPropNum = consume;
                } else if(energy2PropNum >= 1 && !hasEquityMonthTicket){
                    // 有中级精力瓶
                    self.useEnergyPropId = GamePropsType.kEnergy2;
                    self.useEnergyPropNum = 1;
                }
            }
        }
    }

    [StartPanel, StartPanelEvent] = self.createStartPanel()

    function showStartPanel(authorize){
        if (authorize){
            refreshAuthorize()
        }
        StartPanel.show(context.levelId, context.initPropConfig(), context.scoreConfig(), context.levelInfo(), onSuccess, function () {
            Toast.make(getText("error.tip.load_res_error"), 1, context.failCallback)
            window.logCenter && logCenter.error(new Error(`selectLevel failed. StartPanel fail. id=${context.levelId}`), 'selectLevelError')
        }, function () {
            Toast.make(getText("error.tip.load_canceled"), 1, context.failCallback)
        }, self.useEnergyPropId, self.useComplementStarPropId, isReplay);
    }
    if (needPanel) {
        var userMaxLvl = UserManager.getInstance().user.topLevelId
        var savedLvl = cc.UserDefault.getInstance().getStringForKey("authorizelvl")
        if (savedLvl == null)
            savedLvl = 0
        console.log("[####]authorizemanger parma:"+AuthorizeMgr.StartStageLvl+"&"+AuthorizeMgr.StageInterval+"&"+savedLvl)
        if (
            context.levelId >= userMaxLvl && 
            context.levelId > savedLvl &&
            context.levelId >= AuthorizeMgr.StartStageLvl &&
            (context.levelId - AuthorizeMgr.StartStageLvl)%AuthorizeMgr.StageInterval == 0
            ){
                cc.UserDefault.getInstance().setStringForKey("authorizelvl",context.levelId)
                AuthorizeMgr.checkAuthorize(showStartPanel, showStartPanel, getText("wechat.info.ask.level.txt"),"level")
            }else{
                showStartPanel()
            }
    }
    UserScore.getInstance().setLastLevelBeforeLevelEnd(self.levelId); // 开始关卡先记录下最高关卡 
}

StartMainLevelLogic.prototype.createStartPanel = function () {
    [StartPanel, StartPanelEvent] = unpack(require("clover/panel/StartPanel"))

    return  [StartPanel, StartPanelEvent] 
}

StartMainLevelLogic.prototype.onClickAdShow = function (successCallback) {
    var self = this

    // showRewardAni(self.adStartReward)
    // return
    if (!SnsProxy.getInstance().allowAd())
        return;

    function showRewardAni(adStartReward,adStartItmesDc) {
        //如果开始面板关闭不播动画
        if (self.panel.isClosed || !adStartReward){
            // console.log("")
            return
        }
        require("clover/panel/AdStartRewardPanel").create(adStartReward, function(){
            self.isBusy = false
            if (successCallback){
                successCallback(adStartItmesDc)
            }
            // self.dispatchEvent(table([1, "name", StartPanelEvent.AdStartClick]))
        })
        console.log("adstart showreward")
    }

    function fetchAdRewards() {
        //如果开始面板关闭不调fetchadreward接口
        if (self.panel.isClosed){
            return
        }

        function onSuccess(evt) {
            console.log("adstart fetchAdRewards evt.data", evt.data)
            if (evt.data && evt.data.rewardItems){
                // DCAssist.dc4User101("bef_stage_ad","ad_finish",{ad_type: "finish", num: evt.data.preAdNum })
                DCAssist.dc4AdFinish("bef_stage_ad","ad_finish",{num: evt.data.preAdNum })

                // evt.data.rewardItems.forEach(adprop => {
                //     if (adprop){
                //         DCAssist.dc4GetThings(adprop.itemId, adprop.num, "bef_stage_ad", {})
                //     }
                // })

                //读取的reward再转换一次作为真正的奖励
                var adStartReward = AdStartPropManager.getInstance().adPropsToProps(evt.data.rewardItems, self.panel.initPropConfig)
                // console.log("adstart adstartreward 第二次转换trans", adStartReward)
                //看广告结束后播动画
                showRewardAni(adStartReward,evt.data.rewardItems)
            }
        
            AdStartPropManager.getInstance().resetAndStorage()
            
        }
        function onFail(event) {
            // Toast.make("adstart fetchrewarderror"+event)
            let text
            if (event.data > 0) {
                text = getText("error.tip." + event.data)
            }else {
                text = "网络出了点问题哦~"
            }

            function okCallback() {
                // retryTime = 2
                fetchAdRewards()
            }
            function cancelCallback() {
                // cc.Director.getInstance().popScene()
            }
            let data = {
                text : text,
                needOkBtn : true,
                needCancelBtn : true,
                okBtnText : "重试",
                cancelBtnText : "退出"
            }
            require("clover/sns/SnsProxy").getInstance().showDialog(data, okCallback, cancelCallback)


            self.isBusy = false;
        }

        function onCancel() {
            Toast.make(getText("clover.text.385"))
            self.isBusy = false;
        }

        var http = FetchAdRewardHttp.new(true)
        http.addEventListener(Events.kComplete, onSuccess)
        http.addEventListener(Events.kError, onFail)
        http.addEventListener(Events.kCancel, onCancel)
        http.load(AdManagerAdType.preAd);
    }
    
    if (self.ttUseDiamond && TTUtil.isOpenSmallPay()){
        TTUtil.smallPay({
            "type" : "bef_stage_ad",
            "goodName" :"关前特效"
        },()=>{
            fetchAdRewards();
        },()=>{
            self.isBusy = false
        })
        return
    }

    function dropoutAdWatch() {
        Toast.make(getText("error.tip.dropout_ad"));
        self.isBusy = false;

        // DCAssist.dc4User101("bef_stage_ad","ad_dropout",{ad_type: "ad_dropout"})
        DCAssist.dc4AdDropOutNew("bef_stage_ad","ad_dropout")
    }

        
    var snsProxy = SnsProxy.getInstance();
    snsProxy.showAd("AdStartProp")
    .then(isEnd=> {
        // DCAssist.dc4User101("bef_stage_ad","ad_show",{ad_type: "show"})

        if (isEnd) {

                fetchAdRewards();
            } else {
            
            dropoutAdWatch();
        }
    },(err)=>{
        
        if (err && err.errMsg){
            Toast.make(err.errMsg)
        }else{
            Toast.make(getText("video.ad.error"));
        }
        self.isBusy = false;
        // DCAssist.dc4User101("bef_stage_ad","noAds",{ad_type: "noAds"})
        DCAssist.dc4AdNoMore("bef_stage_ad","noAds")
    }).catch(err=> {
        self.isBusy = false;
        
        Toast.make(getText("video.ad.error"));
        // DCAssist.dc4User101("bef_stage_ad","noAds",{ad_type: "noAds"})
        DCAssist.dc4AdNoMore("bef_stage_ad","noAds")
    })

}

StartMainLevelLogic.prototype.scoreConfig = function () {
    var self = this
    var score = UserScore.getScore(self.levelId)
    var levelConfig = LevelConfigManager.getInstance().getGameplayLevelDigestConfigByID(self.levelId, false, score.star) || table()
    var scoreTargets = levelConfig.scoreTargets || table()
    return table(
        [1, "score", score.score],
        [1, "star", score.star],
        [1, "totalStar", Math.max($len(scoreTargets), score.star)],
        [1, "isHardLevel", levelConfig.isHardLevel]
    )
}
StartMainLevelLogic.prototype.initPropConfig = function () {
    var self = this
    var ret = table()
    let infiState = UserManager.getInstance().isInfiPrePropState(self.levelId)
    let infiProp = UserManager.getInstance().getInfiPrePropTime(self.levelId)
    var gameMode = LevelConfigManager.getInstance().getLevelGameMode(self.levelId)
    var gamePropMeta = MetaManager.getGameModePropByModeId(gameMode)
    var topLevel = UserManager.getInstance().getUserRef().getTopLevelId()

    let obj = gamePropMeta.initProps_item || table()

    for (var index in obj) {
        var v = obj[index]
        //  这里的propId为策划的Item表ID，itemId为道具Id(这把名字调过来只是因为以前的代码都用的itemId，怕改出问题)，goodsId为meta_client.xml中的数据
        var elem = table([1, "itemId", ItemDataManager.getPropIdByItemId(v[0])])
        elem.propId = v
        var goodsId = UserDealData.getGoodsIdForProp(elem.itemId)
        elem.num = UserProp.getInstance().getPropNumber(elem.itemId)[0]
        var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
        if (ItemDataManager.getItemPayType(v[0]) === ItemDataManager.PayTypeEnum.Coin) {
            elem.coin = true
            elem.cash = false
        } else {
            elem.coin = false
            elem.cash = true
        }
        elem.locked = goodsMeta.level > topLevel
        if (UserManager.getInstance().getGroupByKey(MetaManager.prePropsGuideConfig.ab_test_name) == "b"){
            elem.locked =  MetaManager.prePropsGuideConfig.unlock_lv > topLevel
        }
        elem.lockedNeedPassLevel = ItemType.isPassLevelPropLock(elem.itemId, self.levelId)
        elem.level = goodsMeta.level
        table.insert(ret, elem)
        if (infiState && !elem.locked && !elem.lockedNeedPassLevel) {
            elem.infi = infiProp
            table.insert(self.initProps, v)
        } else {
            elem.infi = 0
        }

        let [litmitedProp, expireTime] = UserProp.getInstance().getLitmitedPreProp(elem.itemId)
        if (UserProp.getInstance().getInfinitePreProp(elem.itemId) && !elem.locked && !elem.lockedNeedPassLevel){ //限时不限次道具
            //  = UserProp.getInstance().getInfinitePreProp(elem.itemId)
            // elem = table.clone(elem);
            let [infiniteProp, expireTime] = UserProp.getInstance().getInfinitePreProp(elem.itemId)
            elem.expireTime = expireTime
            // [elem.itemId, elem.expireTime] = UserProp.getInstance().getInfinitePreProp(elem.itemId) 
            // elem.num = UserProp.getInstance().getPropNumber(elem.itemId)[0] //只可能为1
            table.insert(self.initProps, infiniteProp)
        } else if(litmitedProp && !elem.locked && !elem.lockedNeedPassLevel){
            elem.expireTime = expireTime
            elem.litmitedProp = litmitedProp;//限次
            elem.num += UserManager.getInstance().getUserTimePropNumber(litmitedProp);
        }
    }
    return ret
}
StartMainLevelLogic.prototype.levelInfo = function () {
    var self = this
    var ret = table([1, "gameplayMode", LevelConfigManager.getInstance().getLevelGameMode(self.levelId)])
    var levelType = LevelType.getLevelTypeByLevelId(self.levelId)
    if (levelType !== GameLevelType.kMainLevel) {
        ret.levelType = levelType
    } else {
        ret.levelId = self.levelId
    }
    return ret
}
StartMainLevelLogic.prototype.checkEnergy = function (panel, param) {
    var self = this
    var [success, errCode] = UserLevel.getInstance().canStartLevel(self.levelId, self.initProps)
    if (success) {
        return true
    } else if (errCode === ZooErrorCode.ENERGY_NOT_ENOUGH) {
        PopoutManager.getInstance().removeAll();
        let cachedMarketEntry = MarketManager.getInstance().getRealCashGoodsEntry4dc();
        MarketManager.getInstance().setCashGoodsEntry(MarketManager.CashGoodsEntry.BuyPropBeforeStage);
        require.ensure([], () => {
            require("clover/panel/EnergyPanel").showEnergyPanel(self.levelId, function () {
                MarketManager.getInstance().setCashGoodsEntry(cachedMarketEntry);
                cachedMarketEntry = null;
                self.startLevel(panel, param)
            }, function () {
                MarketManager.getInstance().setCashGoodsEntry(cachedMarketEntry);
                cachedMarketEntry = null;
                if (type(self.failCallback) === "function") {
                    self.failCallback()
                }
            })
        }, null, 'act')
        return false
    } else {
        PopoutManager.getInstance().removeAll()
        Toast.make(getText("error.tip." + tostring(errCode)))
        self.isBusy = false
        if (type(self.failCallback) === "function") {
            self.failCallback()
        }
        window.logCenter && logCenter.error(new Error(`selectLevel failed. checkEnergy fail. errCode=${tostring(errCode)}`), 'selectLevelError')
        return false
    }
}
StartMainLevelLogic.prototype.checkUseEnergyProp = function (data) {
    let self = this
    // no need
    if (!data) {
        return
    }
    // check
    let num = UserProp.getInstance().getPropNumber(data.itemID)[0]
    if (num >= data.itemNum) {
        let props = table()
        let $limit57 = data.itemNum
        for (let i = 1; i <= $limit57; i += 1) {
            table.insert(props, data.itemID)
        }
        UserProp.getInstance().useProp(props, 0, null, function () {
            DCAssist.dc4EnergyPropStartGame(data.itemID, true, data.itemNum)
        }, function (err) {
            Toast.make(getText("error.tip." + tostring(err.data)))
        }, null, ModuleName.STAGE_START)
    }
}
StartMainLevelLogic.prototype.refreshInitPropCharge = function () {
    var self = this
    var HomeScene = require("clover/scene/HomeScene")
    if (!HomeScene.created) return

    var infoBanner = HomeScene.getInstance().infoBanner
    infoBanner.releaseCoin(self.lockedCoin)
    infoBanner.releaseCash(self.lockedCash)
    ;[self.lockedCoin, self.lockedCash] = [0, 0]
    let infiPropState = UserManager.getInstance().isInfiPrePropState(self.levelId)
    for (var i = 1, v = self.initProps[1]; v; i++, v = self.initProps[i]) {
        if (UserProp.getInstance().getPropNumber(v)[0] <= 0 && (!infiPropState)) {
            var goodsId = UserDealData.getGoodsIdForProp(v)
            var discountGoodsId = UserDealData.getDiscountGoodsIdIfAvaliable(goodsId, 1)
            var meta, payType
            if (discountGoodsId) {
                meta = MetaManager.getInstance().getGoodsMeta(discountGoodsId)
                payType = UserDealData.getGoodsPayType(discountGoodsId)
            } else {
                meta = MetaManager.getInstance().getGoodsMeta(goodsId)
                payType = UserDealData.getGoodsPayType(goodsId)
            }
            if (payType === UserDealPayType.kCoin) {
                self.lockedCoin = self.lockedCoin + meta.coin
            } else if (payType === UserDealPayType.kCash) {
                self.lockedCash = self.lockedCash + (meta.discountQCash !== 0 && meta.discountQCash || meta.qCash)
            }
        }
    }
    infoBanner.lockCoin(self.lockedCoin)
    infoBanner.lockCash(self.lockedCash)
}
StartMainLevelLogic.prototype.cleareInitPropCharge = function () {
    var self = this
    var HomeScene = require("clover/scene/HomeScene")
    if (!HomeScene.created) return

    var infoBanner = HomeScene.getInstance().infoBanner

    infoBanner.releaseCoin(self.lockedCoin)
    infoBanner.releaseCash(self.lockedCash)
    self.lockedCoin = 0
    self.lockedCash = 0
}
StartMainLevelLogic.prototype.checkCompleteNewUserTask = function (props) {
    let isUserPreProp = false
    console.log("[NewUserTask] checkCompleteNewUserTask props ",props)
    props.forEach(v=> {
        if (v && !ItemType.isPreAddScore(v)){
            isUserPreProp = true
        }
    });
    console.log("[NewUserTask] checkCompleteNewUserTask isUserPreProp ",isUserPreProp)
    if (isUserPreProp){
        // 
        NewUserTaskManager.getInstance().tryCompleteTask(NewUserTaskManager.TASK_TYPE_ENUM.use_preprop)
    }

}
// 获取活动关前投放道具
StartMainLevelLogic.prototype.getActPreProp = function () {
    let self = this
    let data = table()
    let props = table(
        [1, 1, 8006],
        [1, 2, 8001],
        [1, 3, 8001],
        // [1, 4, 8001],
        [1, 5, 8002],
        [1, 4, 8004]
    )
    if (PurpleAmyMagicManager.getInstance().isUseByLevel(self.levelId)){
        data.purpleAmyMagic = table()
        data.purpleAmyMagic.props = PurpleAmyMagicManager.getInstance().getRewardsCur()
        data.purpleAmyMagic.needNear = PurpleAmyMagicManager.getInstance().getNearPercent()
        data.purpleAmyMagic.streakBuff = PurpleAmyMagicManager.getInstance().getInfo().streakBuff
    }

    return data
}

StartMainLevelLogic.prototype.startLevel = function (panel, params) {
    var self = this
    var context = self    
    // 当前选中的关前广告道具
    let adPropIds = (params && params.hasOwnProperty("adPropIds"))? params["adPropIds"]: (panel && panel.adPrepropCmpt && panel.adPrepropCmpt.getSelectedPropIds());
    //看广告开始使用的道具
    let adStartPropIds = (params && params.hasOwnProperty("adStartPropIds"))? params["adStartPropIds"] : null;
    function isChallenge() {
        return typeof self.extraData.contestUid !== "undefined"
    }
    function onSuccess() {
        
        // step.110 新用户第一关点击开始
        if (_G.kIsNewUser && !_G.hasFirstStartedLevelOne) {
            _G.hasFirstStartedLevelOne = true;
            //   DCAssist.dcForGameLoading(110, true);
        }
        DCAssist.dc4LevelUserOp110(context.levelId)
        
        try
        {
            require("clover/scene/component/homescene/IslandBook/IslandBookManager").getInstance().recordFullStar(context.levelId)
        }
        catch (e)
        {

        }
        
        // PopoutManager.getInstance().removeAll()
        let loadId = LoadingPanelLogic.getInstance().add("加载中...")
        if (type(context.successCallback) === "function") {
            context.successCallback()
        }
   
        let props = context.initProps? table.clone(context.initProps): table();
        let dcOtherUseProps = table()
        if (adPropIds && adPropIds.length > 0) {
            adPropIds.forEach(v=> {
                if (UserAdPropToPropRef[v]) {
                    table.insert(props, parseInt(UserAdPropToPropRef[v]));
                }
            });
        }
        self.checkCompleteNewUserTask(props)
        if (adStartPropIds && adStartPropIds.length > 0){
            adStartPropIds.forEach(v=> {
                if (v) {
                    table.insert(props, parseInt(v));
                }
            });
        }
        //无限道具转换成基础道具，为了不显示时间条
        table.each(props, function(v, k){
            props[k] = parseInt(UserPropData.transformOriPreProp(v) )
        })
        // 测试代码
        // table.insert(props, parseInt(10011));
        // table.insert(props, parseInt(GamePropsType.kSalvageGiftAdd5));

        // table.insert(props, parseInt(10031));
        SalvageGiftManager.getInstance().getData().cleanUseAddStepState()
        let isPassTopLvFirst = !UserManager.getInstance().reachTopLevel() && context.levelId == UserManager.getInstance().user.topLevelId
        if (isPassTopLvFirst || LevelType.isMysteryIslandLevel(context.levelId)) {     
            if (SalvageGiftManager.getInstance().getData().useAddStep()){
                table.insert(props, parseInt(GamePropsType.kSalvageGiftAdd5))
                table.insert(dcOtherUseProps, parseInt(GamePropsType.kSalvageGiftAdd5))
            }
        }

        // props = table(56, 10008, 10009, 10009, 10011, 10011)
        console.log("adstart startlevel props", props)
        let loadLevelConfigCb = (isLoadLoading)=>{
            if (isLoadLoading){
                LoadingPanelLogic.getInstance().remove(loadId)
                PopoutManager.getInstance().removeAll()
            }
        }
        let instance = CreateGameSceneLogic.create(context.levelId, props, self.extraData.wantedId,loadLevelConfigCb)
        if (isChallenge()) {
            instance.setOtherData(self.extraData)
        }
        instance.setMysteryIsland(self.mysteryIsland)
        instance.setActPreProp(self.getActPreProp())
        // 给打点用的
        instance.setAdPropIds(adPropIds)
        instance.setStartLogicData({
            initProps: context.initProps,
            litmitedProps: self.litmitedProps,
            dcOtherUseProps: dcOtherUseProps
        })

        
        if (params){
            instance.setAdStartItmesDc(params.adStartItmesDc)
        }
        
        instance.startGamePlayScene(function (fileList) {
            // 扣除道具已经在开始关卡的时候使用
            // 这里直接离线扣除道具
            let retryTime = 2
            var consumeEnergy = getMainHideLevelConsumeEnergy(context.levelId, true)
            //看广告开始不消耗精力
            if (isChallenge() || adStartPropIds || self.useComplementStar) {
                consumeEnergy = 0
            }
            UserManager.getInstance().setConsumeEnergy(!!consumeEnergy);
            function success(event) {
                _G.lastStartLevelHttpInfo = {
                    props : props,
                    levelCollectionType : event.data.levelCollectionType,
                    actPreProp : self.getActPreProp(),
                    mysteryIsland : self.mysteryIsland
                }
                console.log("_G.lastStartLevelHttpInfo", _G.lastStartLevelHttpInfo)
                event.target.removeAllEventListeners()
                // 开始关卡获取付费和难度标签
                if (event.data.levelLabel){
                    let t = event.data.levelLabel;
                    console.log("【掉落优化tag】 startlevel接口返回的掉落标签数据 ",t)
                    UserTagData.getInstance().refreshOrthByStartLevel(t.payNum, t.individualDiff, t.natureDiff, t.completeExpect, t.levelPersonDiff, t.levelNatureDiff, t.targetComplete);
                }else{
                    // UserTagData.getInstance().refreshOrthByStartLevel(0);
                }
                UserEnergy.getInstance().unlockEnergy(consumeEnergy)
                UserEnergy.getInstance().consumeEnergy(consumeEnergy,self.levelId)
                // var itemList = table()
                // for (var i = 1, v = context.initProps[1]; v; i++, v = context.initProps[i]) {
                //     if(!UserPropData.isLitmitedPreProp(v)) {
                //         table.insert(itemList, v)
                //     } else {
                //         //getAndUpdateTimeProps会把过期的销毁,导致consumeProp前端会再次扣除未过期的。
                //         if(self.litmitedProps && self.litmitedProps[v] && self.litmitedProps[v] <= UserManager.getInstance().getUserTimePropNumber(v)) {
                //             UserManager.getInstance().useTimeProp(v);
                //         } else {
                //             //
                //             console.log("user prop", v);
                //         }
                //         let pArr = table()
                //         table.insert(pArr, {itemId: v, num: 1})
                //         DCAssist.dc4UseThings(pArr, ModuleName.BEFORE_STAGE, {level:self.levelId}, UserManager.getInstance().getUserTimePropNumber(v) + 1,`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`)
                //     }
                // }
                // if ($len(itemList) > 0) {
                //     UserProp.getInstance().useProp(itemList, context.levelId, null, null, null, null, ModuleName.BEFORE_STAGE ,false)
                // }
                instance.adRefreshCount = event.data.adRefreshCount
                // 设置主线收集活动的 收集类型
                if (!isChallenge() && UserManager.getInstance().playMaxLevelNotReachTopLevel(context.levelId) 
                || LevelType.isMysteryIslandLevel(context.levelId)){
                    instance.setLevelCollectType(event.data.levelCollectionType)
                    let lvManager = LevelCollectManager.getInstance()
                    if (event.data.levelCollectionType  > 0 && lvManager && (event.data.levelCollectionType != lvManager.getActType() ||
                    lvManager.getRewards().length <= 0)){
                        // startlevel返回有levelCollectionType 但是本地与其不相符合 请求info更新信息
                        lvManager.cleanDoubleCardBuffEnd() //活动可能切换先清空
                        lvManager.infoHttp().then(function () {
                            lvManager.updateMainNode(null,0)
                        }).catch((evt) => {

                        })
                    }
                }
                let goCreateGameScene = ()=>{
                    LoadingPanelLogic.getInstance().remove(loadId)
                    PopoutManager.getInstance().removeAll()
                    instance.createGamePlayScene(fileList)
                }
                if (!isChallenge()){
                    // 这里判断超鸟如果startlevel返回超鸟开放但当前超鸟未开发先加载config再进入游戏
                    let mgr = NuclearBirdManager.getInstance()
                    let mData = mgr.getData()
                    mData.loadConfig().then(()=>{
                        mData.updateInfo(event.data.superMagicBirdInfo)
                        // mData.updateInfo({
                        //     begin: 1740362400000,
                        //     end: 1742486399000,
                        //     energyNeed: 5,
                        //     passNum: 6,
                        //     roundId: 1,
                        //     winWithBird: 1
                        // })
                        cc.log("【掉落优化tag】 getWinWithBirdLevelCount=" + tostring(NuclearBirdManager.getInstance().getWinWithBirdLevelCount()))
                        cc.log("【掉落优化tag】 getPreActivateLevelCount=" + tostring(NuclearBirdManager.getInstance().getPreActivateLevelCount()))
                        goCreateGameScene()
                    }).catch(()=>{
                        // 这里如果配置没加载会判定活动未未开放 进入游戏将不会显示超鸟
                        goCreateGameScene()
                    })
                }else{
                    goCreateGameScene()
                }
        
            }
            function onFail(event) {
                event.target.removeAllEventListeners()
                UserEnergy.getInstance().unlockEnergy(consumeEnergy)
                retryTime --
                let text
                if (event.data > 0) {
                    text = getText("error.tip." + event.data)
                }else {
                    text = "网络出了点问题哦~"
                }
                if (retryTime > 0) {
                    // 无法开始关卡时可能上一关未通关，重新发送上一次的打关记录
                    if (event.data == "760602") {
                        UserLevel.getInstance().uploadLastScore(startLevel, startLevel, startLevel)
                    } else {
                        startLevel()
                    }
                }else {
                    function okCallback() {
                        retryTime = 2
                        startLevel()
                    }
                    function cancelCallback() {
                        cc.Director.getInstance().popScene()
                    }
                    let data = {
                        text : text,
                        needOkBtn : true,
                        needCancelBtn : true,
                        okBtnText : "重试",
                        cancelBtnText : "退出"
                    }
                    require("clover/sns/SnsProxy").getInstance().showDialog(data, okCallback, cancelCallback)
                }
            }
            function onCancel(event) {
                event.target.removeAllEventListeners()
                UserEnergy.getInstance().unlockEnergy(consumeEnergy)
            }
            function startLevel() {
                UserEnergy.getInstance().lockEnergy(consumeEnergy)
                let otherData = self.extraData
                //后续确认是用主线关卡还是神秘岛关卡号
                // let load_levelId = context.levelId
                // if (self.mysteryIsland) load_levelId = self.mysteryIsland.mainLevelId
                require("clover/logic/userLevel/UserLevelTypeBase").prototype.startLevel.call(null, context.levelId, context.initProps, success, onFail, onCancel, otherData, adPropIds)
            }
            startLevel()
        })
    }
    function playConsumeEnergyAnimation() {
        // body
        context.cleareInitPropCharge()
        context.waitingPanelAnim = true
        //看广告开始不播放精力消耗动画
        if (panel && panel.playConsumeEnergyAnimation && !adStartPropIds && !self.useComplementStar) {
            panel.playConsumeEnergyAnimation(onSuccess)
        } else {
            onSuccess()
        }
    }
    function onFail(event) {
        Toast.make(curryQuickGetErrorText(event && event.data || 0))
        context.isBusy = false
        if (type(context.failCallback) === "function") {
            context.failCallback()
        }
        window.logCenter && logCenter.error(new Error(`selectLevel failed. load level config fail. id=${self.levelId}`), 'selectLevelError')
    }
    function onCancel() {
        context.isBusy = false
        if (type(context.failCallback) === "function") {
            context.failCallback()
        }
    }

    // 预先加载meta文件，防止加载文件失败
    let load_levelId = self.levelId 
    if (self.mysteryIsland) load_levelId = self.mysteryIsland.mainLevelId//    //后续确认是用主线关卡还是神秘岛关卡号

    let path = LevelConfigManager.getInstance().getLevelConfigPath(load_levelId,self.mysteryIsland)
    cc.loader.load(path, function (err) {
        if (err) {
            onFail({data:301})
        }else {
            dcForGameLoadingTooLang(load_levelId)
            UserLevel.getInstance().startLevel(self.levelId , self.initProps, playConsumeEnergyAnimation, onFail, onCancel, true, self.extraData, adPropIds, adStartPropIds)        
        }
    })
}

StartMainLevelLogic.prototype.usePropAndStart = function(propData){
    var self = this;
    var props = table();
    var propId = 0;
    for(var i = 0; i < propData.num; i++){
        props.push(propData.propId);
        propId = propData.propId;
    }
    cc.log("useProp", props);
    cc.log("gameplayMode", self.panel.levelInfo.gameplayMode);
    var energyParam = {
        level: self.levelId,
        stageMode: self.panel.levelInfo.gameplayMode
    };
    UserProp.getInstance().useProp(props, 0, null, function () {
        var [currentEnergy, recoverTime] = UserEnergy.getInstance().getEnergy();
        self.playUseEnergyPropAnim(propId);
    }, function (err) {

        if (tonumber(err.data) > 0){
            
            Toast.make(getText("error.tip." + tostring(err.data)));
        }else{
            //网络异常，请退出重试
            Toast.make(getText("error.tip.-1"));
        }
        // console.error("tonumber(err.data) NaN", tonumber(err.data) == NaN)
        // console.error("parseInt(err.data) NaN", parseInt(err.data) == "NaN")
        // console.error("parseInt(err.data) NaN", isNaN(parseInt(err.data)))

        self.isBusy = false
    }, null, ModuleName.BEFORE_STAGE, null, energyParam);
}

StartMainLevelLogic.prototype.playUseEnergyPropAnim = function(propId){
    var self = this;
    if (propId == GamePropsType.kEnergy1 || propId == GamePropsType.kEnergy2 || propId == GamePropsType.kEnergy3){
        self.panel.showEnergyAnim(propId);
    }else if (propId == GamePropsType.kComplementStar || propId == GamePropsType.kComplementStar2){
        self.panel.showComplementStarAnim(propId);
    }else{
        self.panel.showEnergyAnim(propId);
    }
}

StartMainLevelLogic.prototype.gotoStrategy = function() {
    var self = this;
    const strategyId = self.strategyId;
    const strategyContent = self.strategyContent;
    if(strategyId) {
        require("clover/gamePlay/CreateGameSceneLogic");
        var logic = CreateGameSceneLogic.create(self.levelId, table()); //攻略不用道具
        logic.startStrategyReplayGamePlayScene(self.levelId, true, strategyId, strategyContent);
        DAManager.getInstance().refreshEndLevelStatus(false, true) //攻略面版关闭或播放攻略
    }
}

StartMainLevelLogic.prototype.showAdPrompt = function(ad,cb) {
    var self = this;
    var checkMark = cc.UserDefault.getInstance().getBoolForKey(LOCAL_STRATEGY_CHECK_TIP, false);
    if (checkMark && ad){
        self.showAd(cb);
        return
    }
    var showAd = self.showAd.bind(self,cb);
    var success = function(){
        cb();
        if (ad){
            require("clover/panel/LosePanelStrategyPrompt").create(self.strategyId, showAd);
        }else{
            // if (SnsProxy.getInstance().allowShare()){
            //     require("clover/panel/LosePanelStrategyPromptNoAd").create(self.strategyId, self.levelId);
            // }else{
            //     Toast.make(getText("leveltip.noad.text"))
            // }
            Toast.make(getText("leveltip.noshare.text"))
        }
    }
    preloadWithLoading(["packed/StrategyAdPrompt.pack"], success, function () {
        cb();
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        cb();
        Toast.make(getText("error.tip.load_canceled"))
    })
}

StartMainLevelLogic.prototype.showAd = function(cb) {
    var self = this;
    var gotoStrategy = self.gotoStrategy.bind(self);

    DCAssist.dc4AdClick("levelTip", "ad_start");
    var snsProxy = require("clover/sns/SnsProxy").getInstance();
    snsProxy.showAd("Startegy")
    .then(isEnd=> {
        cb();
        if (isEnd) {
            DCAssist.dc4AdFinish("levelTip", "ad_finish", {"num": self.levelId});
            gotoStrategy();
        } else {
            DCAssist.dc4AdDropOut("levelTip", "ad_dropout");
            Toast.make(getText("error.tip.dropout_ad"));
        }
    },(err)=>{
        cb();
        if (err && err.errMsg){
            Toast.make(err.errMsg)
        }else{
            Toast.make(getText("video.ad.error"));
        }
        DCAssist.dc4AdNoMore("levelTip", "noAds");
    })
    .catch(err=> {
        cb();
        Toast.make(getText("video.ad.error"));
        cc.error("wx_video_ad : " + err.errMsg);
            DCAssist.dc4AdNoMore("levelTip", "noAds");
        })
}


function dcForGameLoadingTooLang(load_levelId) {
    _G.gameLoadingTimerId = setTimeout(() => {
        window.logCenter && logCenter.error(new Error("Game loading time is too lang. LevelId="+load_levelId), 'LoadingWarn');
    }, 30 * 1000);
}
module.exports = StartMainLevelLogic
